<!-- <div>
  <po-loading-overlay [hidden]="isHideLoading" [p-text]="textEnviar"></po-loading-overlay>
</div> -->
<app-loading *ngIf="!isHideLoading"></app-loading>


<!-- Imagem do banner no canto superior direito -->
<header class="flex items-center justify-end min-h-[10vh] ">
  <img src="./assets/images/logo_sempre_slogan.png" alt="Banner" class="p-4 w-40 h-auto">
</header>
<!-- Informações de Homologação -->
<div class="bg-yellow-300 text-center py-2">
  <span class="font-bold text-red-600">VERSÃO DE HOMOLOGAÇÃO</span>
</div>


<!-- Formulário -->
<section *ngIf="!lWaiting && !error && !success" class="p-8">

  <div *ngIf="fieldsCC.length" class="space-y-4 max-w-[1600px] mx-auto">
    <!-- Boas Vindas -->
    <div class="p-4 mb-4">
      <h1 class="text-2xl ">Olá, <span class="font-bold" style="color: var(--blue-sempre);">{{label}}</span>!</h1>
      <p class="text-2xl ">Seja bem-vindo(a).</p>
      <p class="mt-2 font-bold text-gray-400" style="color: var(--)">Preencha os dados abaixo para ativar a
        recorrência.
      </p>
    </div>

    <!-- Dados do Contrato -->
    <div class="p-4 mt-6">
      <h2 class="text-lg font-bold mb-4" style="color: var(--blue-80);">Dados do Contrato</h2>
      <po-dynamic-form [p-fields]="fieldsContract" [p-value]="dataContract"></po-dynamic-form>
    </div>

    <!-- Divider -->
    <hr class="my-6">

    <!-- Cartão de Crédito -->
    <div class="p-4 mt-6 flex flex-col-reverse lg:flex-row ">
      <div class="w-full lg:w-2/3">
        <h2 class="text-lg font-bold mb-4" style="color: var(--blue-80);">Cartão de Crédito</h2>
        <po-dynamic-form #dynamicForm [p-fields]="fieldsCC" [p-value]="cardToken">
        </po-dynamic-form>
      </div>
      <div class="flex flex-col w-full lg:w-1/3 justify-center items-center my-4">
        <div class=" w-full lg:w-1/3 flex justify-center items-center">
          <ng-credit-card [name]="cardToken.cardholderName" [number]="cardToken.cardNumber"
            [cvc]="cardToken.securityCode" [expiry]="formatExpiry(cardToken.expirationMonth, cardToken.expirationYear)"
            [focused]="getCardFocus()">
          </ng-credit-card>
        </div>
        <div class="mt-6 w-full  flex justify-center items-center">
          <div class="w-full flex justify-center items-center mt-4 lg:mt-0">
            <po-switch class="custom-switch" name="showCVV" [(ngModel)]="showCVV" p-label="Cartão de Crédito"
              p-label-off="Frente" p-label-on="Verso"
              [hidden]="cardToken.securityCode.length > 0 && cardToken.securityCode.length < 3">
            </po-switch>
          </div>
        </div>

      </div>
    </div>


    <!-- Divider -->
    <hr class="my-6">

    <!-- Endereço de Cobrança -->
    <div class="p-4 mt-6">
      <h2 class="text-lg font-bold mb-4" style="color: var(--blue-80);">Endereço de Cobrança</h2>
      <po-dynamic-form [p-fields]="fieldsBillingAddress" [p-value]="cardToken"></po-dynamic-form>
    </div>

    <!-- Divider -->
    <hr class="my-6">

    <!-- Contato -->
    <div class="p-4 mt-6">
      <h2 class="text-lg font-bold mb-4" style="color: var(--blue-80);">Contato</h2>
      <po-dynamic-form [p-fields]="fieldsContact" [p-value]="cardToken"></po-dynamic-form>
    </div>

    <!-- Divider -->
    <hr class="my-6">

    <div class="flex flex-col-reverse md:flex-row justify-between mt-8 space-y-4 md:space-y-0 md:space-x-4 ">
      <div class="flex flex-col-reverse md:flex-row space-y-4 md:space-y-0 md:space-x-4 gap-4">
        <button class="btn-exit w-full md:w-auto px-4 py-2 text-white rounded" *ngIf="!saving" (click)="close()">
          <i class="po-icon po-icon-exit"></i> Sair
        </button>
        <button class="btn-clear w-full md:w-auto px-4 py-2 border-2 rounded" *ngIf="!saving" (click)="clear()">
          <i class="po-icon po-icon-clear-content"></i> Limpar
        </button>
      </div>

      <div class="pl-0 md:pl-4">
        <button class="btn-send w-full md:w-auto px-4 py-2 text-white rounded" [disabled]="!validPreSend() || saving"
          (click)="send()">
          <i class="po-icon po-icon-ok" *ngIf="!saving"></i>
          {{ saving ? 'Enviando...' : 'Enviar' }}
        </button>
      </div>
    </div>
  </div>
</section>

<!-- Token Inválido -->
<section *ngIf="error">
  <!DOCTYPE html>
  <html lang="pt-br">

  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css"
      integrity="sha512-z3gLpd7yknf1YoNbCzqRKc4qyor8gaKU1qmn+CShxbuBusANI9QpRohGBreCFkKxLhei6S9CQXFEbbKuqLg0DA=="
      crossorigin="anonymous" referrerpolicy="no-referrer" />
    <link rel="stylesheet" href="./card-token.component.scss" />
    <title>Token Inválido</title>
  </head>

  <body>
    <div>
      <!-- MESSAGE SECTION -->
      <main class="main-content-alt min-h-[77vh]">
        <div class="message-body ">
          <p>
            <strong>Olá Cliente Sempre!</strong><br>
          </p>
          <p>
            O token utilizado para sua transação expirou. Por favor, realize uma nova solicitação de token ou entre em
            contato conosco para assistência. Garantimos total segurança em suas transações.
          </p>
          <p>
            Agradecemos pela compreensão.
          </p>
          <p>
            Atenciosamente, <br><strong>Sempre!</strong>
          </p>
        </div>
      </main>

    </div>
    <!-- COMMON SCRIPTS -->
    <script src="https://code.jquery.com/jquery-3.7.1.min.js"
      integrity="sha256-/JqT3SQfawRcv/BIHPThkBvs0OEvtFFmqPF/lYI/Cxo=" crossorigin="anonymous"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery.mask/1.14.16/jquery.mask.min.js"
      integrity="sha512-pHVGpX7F/27yZ0ISY+VVjyULApbDlD0/X0rgGbTqCE7WFW5MezNTWG/dnhtbBuICzsd0WQPgpE4REBLv+UqChw=="
      crossorigin="anonymous" referrerpolicy="no-referrer"></script>
    <script src="./assets/js/scripts.js"></script>
  </body>

  </html>
</section>

<!-- Sucesso no Pagamento -->
<section *ngIf="success">
  <!DOCTYPE html>
  <html lang="pt-br">

  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css"
      integrity="sha512-z3gLpd7yknf1YoNbCzqRKc4qyor8gaKU1qmn+CShxbuBusANI9QpRohGBreCFkKxLhei6S9CQXFEbbKuqLg0DA=="
      crossorigin="anonymous" referrerpolicy="no-referrer" />
    <link rel="stylesheet" href="./card-token.component.scss" />
    <title>Sucesso no Pagamento</title>
  </head>

  <body>
    <div class="">
      <div class="main-tittle">
        <h3>Cadastro realizado com sucesso!</h3>
      </div>

      <!-- MESSAGE SECTION -->
      <main class="main-content-success min-h-[77vh]">
        <div class="message-body">
          <p>
            Prezado Cliente Sempre!
          </p>
          <p>
            <!-- <strong>Informamos que seu pagamento foi confirmado com sucesso!</strong> -->
            <strong>Informamos que seu cartão de crédito foi cadastrado com sucesso!</strong>
          </p>
          <p>
            Agradecemos por escolher a Sempre Assistência Familiar! Muito bom poder contar com a segurança e todos os
            benefícios que só a Sempre te oferece. Lembre-se de que o nosso aplicativo, Sempre App, está disponível
            para
            facilitar ainda mais sua experiência, proporcionando acesso rápido a informações, facilidade de pagamento
            e
            assitência quando necessário.
          </p>

          <div class="sempre-app">
            <p>Sempre App</p>
            <div class="stores">
              <a href="https://apps.apple.com/br/app/sempre-app/id6463144039" target="_blank" rel="noopener noreferrer">
                <img src="./../../../assets/images/app_store.png" alt="Download na App Store" height="40px" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=br.com.planosempre.app&pli=1" target="_blank"
                rel="noopener noreferrer">
                <img src="./../../../assets/images/google_play.png" alt="Disponível no Google Play" height="40px" />
              </a>
            </div>
          </div>

          <p>
            Caso tenha alguma dúvida ou precise de assistência. estamos à disposição. Aproveite sua experiência!
          </p>
          <p>
            Atenciosamente, <br><strong>Sempre!</strong>
          </p>
        </div>
      </main>
    </div>
    <!-- COMMON SCRIPTS -->
    <script src="https://code.jquery.com/jquery-3.7.1.min.js"
      integrity="sha256-/JqT3SQfawRcv/BIHPThkBvs0OEvtFFmqPF/lYI/Cxo=" crossorigin="anonymous"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery.mask/1.14.16/jquery.mask.min.js"
      integrity="sha512-pHVGpX7F/27yZ0ISY+VVjyULApbDlD0/X0rgGbTqCE7WFW5MezNTWG/dnhtbBuICzsd0WQPgpE4REBLv+UqChw=="
      crossorigin="anonymous" referrerpolicy="no-referrer"></script>
    <script src="./../../../assets/js/scripts.js"></script>
  </body>

  </html>
</section>


<!-- FOOTER SECTION -->
<footer class="footer-alt min-h-[12vh]">
  <div class="contact-section-alt">
    <div class="flex justify-between items-center">
      <div class="footer-contact flex space-x-4">
        <div class="footer-divider flex items-center">
          <a href="#" class="footer-icon-link"><i class="fa-solid fa-headset footer-icon"></i></a>
          <span>Fale com <br>a gente</span>
        </div>
        <div class="footer-contact-info footer-divider flex flex-col items-center">
          <strong>(84) 4000.2002</strong>
          <span>Capitais e Regiões <br>Metropolitanas</span>
        </div>
        <div class="footer-contact-info flex flex-col items-center pl-2">
          <strong>0800 402 2002</strong>
          <span>Outras Localidades</span>
        </div>
      </div>
      <div
        class="social-media-section flex flex-col items-center space-y-2 mt-5 lg:mt-0 lg:space-y-0 lg:flex-row lg:space-x-4">
        <a href="https://planosempre.com.br/" class="social-media-link" target="_blank" title="Site">
          <i class="fa-solid fa-globe social-media-icon"></i>
          planosempre.com.br
        </a>
        <div class="flex space-x-4">
          <a href="#" target="_blank" title="Facebook" class="social-media-icon">
            <i class="fa-brands fa-facebook-f"></i>
          </a>
          <a href="#" target="_blank" title="Instagram" class="social-media-icon">
            <i class="fa-brands fa-instagram"></i>
          </a>
          <span class="social-media">planosempre</span>
        </div>
      </div>
    </div>
  </div>
</footer>